import { Outlet, useLocation } from 'react-router-dom'
import Sidebar from './sidebar'
import useIsCollapsed from '@/hooks/use-is-collapsed'
import SkipToMain from './skip-to-main'
import { useSimpleRouteProtection } from '@/hooks/useSimpleRouteProtection';

export default function AppShell() {
  const [isCollapsed, setIsCollapsed] = useIsCollapsed()
  const { pathname } = useLocation()

  const showSidebar = !pathname.startsWith('/magic-link')
  useSimpleRouteProtection();
  return (
    <div className='relative h-full overflow-hidden bg-background'>
      <SkipToMain />
      {showSidebar && (
        <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      )}
      <main
        id='content'
        className={`overflow-x-hidden pt-16 transition-[margin] md:overflow-y-hidden md:pt-0 ${!showSidebar ? 'md:ml-0' : isCollapsed ? 'md:ml-14' : 'md:ml-64'} h-full`}
      >
        <Outlet />
      </main>
    </div>
  )
}
